export default "__VITE_ASSET__BYZx0bHa__"